module.exports = __webpack_public_path__ + "static/media/Engineering_Insurance.b5c8a83d.svg";